export { adminAuth as auth, onAuthStateChanged, signOut } from './adminAppAuth';

export const browserLocalPersistence = { type: 'LOCAL' };
export const browserSessionPersistence = { type: 'SESSION' };

export async function setPersistence() {
  return undefined;
}

export function getAuth() {
  return require('./adminAppAuth').adminAuth;
}

export async function signInWithEmailAndPassword(_auth, email, password) {
  const { loginAdminWithPassword } = await import('../../api/localAuth');
  await loginAdminWithPassword(email, password);
  const { adminAuth } = await import('./adminAppAuth');
  return { user: adminAuth.currentUser };
}

export async function createUserWithEmailAndPassword(_auth, email, password) {
  const { apiRequest } = await import('../../api/client');
  const { setAdminSessionToken } = await import('../../api/authToken');
  const { notifyAdminAuthChanged } = await import('./adminAppAuth');
  const data = await apiRequest('/api/admin/register', {
    method: 'POST',
    body: { email, password },
  });
  if (data?.token) {
    setAdminSessionToken(data.token);
    notifyAdminAuthChanged();
  }
  const { adminAuth } = await import('./adminAppAuth');
  return { user: adminAuth.currentUser };
}

export async function confirmPasswordReset(_auth, token, password) {
  const { consumeAdminPasswordReset } = await import('../../api/localAuth');
  await consumeAdminPasswordReset({ token, password });
}

export async function verifyPasswordResetCode() {
  return '';
}

export class EmailAuthProvider {
  static credential(email, password) {
    return { email, password };
  }
}
